/**
 * YYYY-MM-DD for the calendar date `daysAgo` days before `now`
 * (local `setDate` arithmetic, then `toISOString().slice(0, 10)`).
 */
export const getIsoDateStringDaysAgo = (daysAgo, now = new Date()) => {
  const d = new Date(now.getTime());
  d.setDate(d.getDate() - daysAgo);
  return d.toISOString().slice(0, 10);
};
